import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MultilevelItem } from 'src/app/core/models/multilevel-selector.model';
import { GazeMapService } from 'src/app/core/services/gaze-map.service';

@Component({
  selector: 'hbo-multi-select-multi-level-item',
  templateUrl: './multi-select-multi-level-item.component.html',
  styleUrls: ['./multi-select-multi-level-item.component.scss']
})
export class MultiSelectMultiLevelItemComponent {

  @Input('item') item!: MultilevelItem | undefined;
  @Input('allSelected') allSelected!: MultilevelItem | undefined;
  @Input('data') data!: MultilevelItem[] | undefined;
  @Input('selected') selected!: boolean | undefined;
  @Input("typeData") typeData!: string;
  @Input("search") search!: string;
  dataPartial!: MultilevelItem[] | undefined;
  dataParentsPartial!: MultilevelItem[];

  @Output('callback') callback = new EventEmitter;
  @Output('callbackVisible') callbackVisible = new EventEmitter;
  constructor(
    public gazeMapService: GazeMapService
  ) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {
    this.data?.map((item: MultilevelItem) => item.opened = false);
    this.dataPartial = this.data;
    this.search && this.search.length

      ? this.dataPartial?.map((item: MultilevelItem) => {
        if (item.selected || this.eliminarDiacriticosEs(item.target.name.toLowerCase()).includes(this.eliminarDiacriticosEs(this.search.toLowerCase()))) {
          item.visible = true;
          item.opened = true;
          this.callbackVisible.emit({ 'item': this.item, value: true });
        } else {
          item.opened = false;
          item.visible = false;
          //this.callbackVisible.emit({'item': this.item , value:false});
        }
      })
      : (
        this.data!.map((item: MultilevelItem) => item.visible = true),
        this.callbackVisible.emit({ 'item': this.item, value: true })
      )
    console.log(this.item);


    /*? (
      this.dataPartial = this.data?.filter((item: MultilevelItem) => item.selected || this.eliminarDiacriticosEs(item.target.name.toLowerCase()).includes(this.eliminarDiacriticosEs(this.search.toLowerCase()))),
      console.log(this.dataPartial),
      console.log(this.gazeMapService.currentGazeMapConfigValue.partners),
      this.dataParentsPartial = [],
      this.dataPartial?.map((item: MultilevelItem) => {
        this.dataParentsPartial.push(this.gazeMapService.currentGazeMapConfigValue.partners?.find((elem: MultilevelItem) => elem.target.id == item.target.parentEntityId)!)
      }),
      console.log(this.dataParentsPartial),
      this.dataPartial?.concat(this.dataParentsPartial)
    )
    : this.dataPartial = this.data;*/

    switch (this.typeData) {
      case 'package':
        this.callback.emit(this.item);
        break;
      default:
        switch (this.selected) {
          case true:
            this.item!.all
              ? (
                this.data?.map((item: MultilevelItem) => {
                  item.selected = true;
                  //item.childs?.map((child:MultilevelItem)=>child.selected=true)
                })
              )
              : null
            break;
          case false:
            this.item!.target.entityTypeId != 1 ? this.data?.map((item: MultilevelItem) => item.selected = false) : false;
            break;
          default:
            break;
        }
        this.callback.emit('iterate');
        break;
    }

  }

  visibleEntity(e: { item: MultilevelItem, value: boolean }) {
    console.log(e);
    e.item.visible = e.value;
    this.callbackVisible.emit({ 'item': this.item, value: true });
  }

  eliminarDiacriticosEs(_text: string) {
    return _text
      .normalize('NFD')
      .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
      .normalize();
  }
  toogle(_item: MultilevelItem) {
    if (_item.target.entityTypeId == 4) {
      _item.selected = !_item.selected;
      this.emitChange();
    } else {
      _item.opened = !_item.opened;
    }
  }

  emitChange() {
    let len;
    switch (this.typeData) {
      case 'package':
        /*len = this.data?.filter((item: MultilevelItem) => item.selected).length;
        if (this.item!.target.entityTypeId != 4) {
          !len
            ? this.item!.selected = false
            : this.item!.selected = true;
        }
        len && len == this.data!.length
          ? this.item!.all = true
          : this.item!.all = false;*/
        this.callback.emit('change');
        break;
      case 'gazeMaps':
        len = this.data?.filter((item: MultilevelItem) => item.selected).length;
        if (this.item!.target.entityTypeId != 4) {
          !len
            ? this.item!.selected = false
            : this.item!.selected = true;
        }
        len && len == this.data!.length
          ? this.item!.all = true
          : this.item!.all = false;
        //this.callback.emit('change');
        break;
      case 'fits':
        len = this.data?.filter((item: MultilevelItem) => item.selected).length;
        if (this.item!.target.entityTypeId != 4) {
          !len
            ? this.item!.selected = false
            : this.item!.selected = true;
        }
        len && len == this.data!.length
          ? this.item!.all = true
          : this.item!.all = false;
        //this.callback.emit('change');
        break;
      default:
        break;
    }
  }

  change(e: any, _item: MultilevelItem): void {
    this.emitChange();
    this.callback.emit('change');
    switch (this.typeData) {
      case 'package':
        /*_item.selected && _item.childs?.filter((item: MultilevelItem) => item.selected).length == _item.childs!.length
          ? (
            _item.all = true,
            _item.childs?.map((item: MultilevelItem) => item.selected = true)
          )
          : _item.all = false;
        _item.selected && !_item.childs?.filter((item: MultilevelItem) => item.selected).length
          ? (
            _item.childs?.map((item: MultilevelItem) => {
              item.all = true;
              item.selected = true;
            })
          )
          : null;*/
        //this.callback.emit('iterate');
        break;
      case 'gazeMaps':
        _item.selected && _item.childs?.filter((item: MultilevelItem) => item.selected).length == _item.childs!.length
          ? (
            _item.all = true,
            _item.childs?.map((item: MultilevelItem) => item.selected = true)
          )
          : _item.all = false;
        _item.selected && !_item.childs?.filter((item: MultilevelItem) => item.selected).length
          ? (
            _item.childs?.map((item: MultilevelItem) => {
              item.all = true;
              item.selected = true;
            })
          )
          : null;
        //this.callback.emit('iterate');
        break;
      case 'fits':
        _item.selected && _item.childs?.filter((item: MultilevelItem) => item.selected).length == _item.childs!.length
          ? (
            _item.all = true,
            _item.childs?.map((item: MultilevelItem) => item.selected = true)
          )
          : _item.all = false;
        _item.selected && !_item.childs?.filter((item: MultilevelItem) => item.selected).length
          ? (
            _item.childs?.map((item: MultilevelItem) => {
              item.all = true;
              item.selected = true;
            })
          )
          : null;
        //this.callback.emit('iterate');
        break;
      default:
        break;
    }
  }

  setShops(e: any) {
    this.emitChange();
    this.callback.emit(e);
  }
}
